export const FALLBACK_ASSOCIATION_IMAGE = "/img/no-image.jpg";

export function cn(...classes) {
  return classes.filter(Boolean).join(" ");
}

export function ensureArray(value) {
  return Array.isArray(value) ? value : [];
}

export function stripHtml(html = "") {
  return String(html)
    .replace(/<[^>]+>/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

export function truncateText(value = "", maxLength = 280) {
  const text = String(value || "").trim();
  if (text.length <= maxLength) return text;
  return `${text.slice(0, maxLength - 1).trim()}…`;
}

export function normalizeSearchText(value = "") {
  return String(value || "")
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase()
    .trim();
}

export function normalizeExternalUrl(value = "") {
  const url = String(value || "").trim();
  if (!url) return "";

  if (/^https?:\/\//i.test(url)) return url;
  return `https://${url}`;
}

export function normalizePhoneHref(value = "") {
  const phone = String(value || "")
    .replace(/\s+/g, "")
    .replace(/[().-]/g, "");

  return phone ? `tel:${phone}` : "";
}

export function buildMapsHref({ gps, address }) {
  const gpsValue = String(gps || "").trim();
  const addressValue = String(address || "").trim();

  if (gpsValue) {
    return `https://www.google.com/maps?q=${encodeURIComponent(gpsValue)}`;
  }

  if (addressValue) {
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
      addressValue
    )}`;
  }

  return "";
}

export function buildMapEmbedUrl({ gps, address }) {
  const gpsValue = String(gps || "").trim();
  const addressValue = String(address || "").trim();
  const query = gpsValue || addressValue;

  if (!query) return "";

  return `https://maps.google.com/maps?q=${encodeURIComponent(
    query
  )}&z=15&output=embed`;
}

export function normalizeAssociation(association, options = {}) {
  const resolveLogoUrl = options.resolveLogoUrl || ((value) => value);

  const logo = association?.logo_asso
    ? resolveLogoUrl(association.logo_asso)
    : "";

  const title = association?.nom_asso || "Association";
  const description = truncateText(
    stripHtml(association?.description_asso || ""),
    330
  );

  const address = String(association?.adresse_asso || "").trim();
  const gps = String(association?.gps_asso || "").trim();

  const websiteUrl = normalizeExternalUrl(association?.website_asso);
  const facebookUrl = normalizeExternalUrl(association?.facebook_asso);
  const phone = String(association?.tel_asso || "").trim();
  const mail = String(association?.mail_asso || "").trim();

  const contactLabel = [association?.contact_asso, association?.fonction_asso]
    .filter(Boolean)
    .map((value) => String(value).trim())
    .join(" · ");

  const mapsHref = buildMapsHref({ gps, address });
  const mapEmbedUrl = buildMapEmbedUrl({ gps, address });

  const category = association?.categorie || "";

  const searchIndex = normalizeSearchText(
    [
      title,
      category,
      description,
      contactLabel,
      phone,
      mail,
      websiteUrl,
      facebookUrl,
      address,
      gps,
    ]
      .filter(Boolean)
      .join(" ")
  );

  return {
    id: association?.id,
    raw: association,

    title,
    category,
    description,

    contactLabel,
    phone,
    phoneHref: normalizePhoneHref(phone),
    mail,

    websiteUrl,
    facebookUrl,

    address,
    gps,
    hasMap: Boolean(address || gps),
    mapsHref,
    mapEmbedUrl,

    image: logo || FALLBACK_ASSOCIATION_IMAGE,

    searchIndex,
  };
}